<template>
    <div class="d-flex flex-column">

        <!-- Tabla con datos -->
        <div style="height:350px; overflow-y:scroll;">
            <table v-if="showTable" id="tabla_consolidado_anual" class="table table-striped  w-100">
                <thead>
                    <th class="text-center">*</th>
                    <th class="text-center">Puerto destino</th>
                    <th class="text-center">Contenedor</th>
                    <th class="text-center">Tipo producto</th>
                    <th class="text-center">Consignatario(s)</th>
                    <th class="text-center">Carga anual</th>
                    <th>Opciones</th>
                </thead>

                <tbody>
                    <tr v-for="(fila, fila_index) in dataAux" :key="fila_index">
                        <template v-for="(data, index_data) in fila.data">

                            <td :key="index_data" class="text-center" v-if="index_data == 0">
                                <ui-checkbox v-model="fila.data[index_data]" style="margin-top: 5px;" @change="checkFila($event, fila_index)"></ui-checkbox>
                            </td>

                            <td :key="index_data" v-else class="text-center">{{ data }}</td>
                        </template>

                        <td>
                            <i class="p-2" style="cursor:pointer" v-for="(item, index) in fila.acciones" :key="index" :class="item.icon" :title="item.title" @click="seleccionarAcciones(fila_index, item.title)"></i>
                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td class="text-center"><b>Total carga</b></td>
                        <td colspan="4"></td>
                        <td class="text-center"><b v-text="totalAnual"></b></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
        </div>
       
    </div>
</template>

<script>

    // Vue
    import Vue from "vue";

    // Toast
    import VueToastify from "vue-toastify";
    Vue.use(VueToastify);

    import { mapActions, mapState } from 'vuex';
    import { eliminarPuertos } from '../../../../constants/lineas';

    export default {
        props: ['data','totalAnual'],

        computed: {
            ...mapState('lineas',["puertosSeleccionadosPlanAnual","dataAnioSeleccionado","nuevosConsolidadoMultiples",
                        "puertoParaEliminarPlanificacionAnual","checkPlanificacionAnual"]),
        },

        data() {
            return {
                dataAux : [],
                acciones : [],
                check_seleccionados : [],
                showTable : true
            }
        },

        methods : {

            ...mapActions('lineas',["actionSetPuertosSeleccionadosPlanAnual","actionSetCheckPlanificacionAnual",
                                    "actionSetNuevosPuertosMultiples","actionSetPuertoParaEliminarPlanificacionAnual",
                                    "actionSetDataPlanificacionAnualTabla"]),

            async generarBotonesAcciones(dataAux) {

                this.acciones = [];
                this.showTable = false;

                setTimeout(() => this.showTable = true, 100);

                await Object.keys(dataAux).map((_, index) => {

                    let {id, data} = dataAux[index];
                    let dataTemp = [false, ...data]

                    this.dataAux.push({
                        "id_puerto" : id,
                        "data" : dataTemp,
                        "acciones" : [
                            {
                                icon: "fa fa-times text-danger",
                                title: "Eliminar puerto",
                                id: index,
                            }
                        ]
                    });

                });

            },

            async seleccionarAcciones(index, accion){

                let puerto = '';

                switch (accion) {
                    case 'Eliminar puerto':

                        puerto = await this.dataAux[index].data[1];

                        this.$vToastify.prompt({
                            body: `"¿Desea eliminar el puerto ${puerto}?"`,
                            answers: { Sí: true, No: false },
                        }).then(
                            (respuesta) => respuesta && this.eliminarFila(index)
                        );

                        break;
                }
            },

            checkFila(event, index){

                let estado         = event;
                let check_filtrado = [];

                if (estado) {

                    let checkListTemp = [{id: index, data : this.dataAnioSeleccionado[index], checked: true} , ...this.checkPlanificacionAnual]

                    this.actionSetCheckPlanificacionAnual(checkListTemp);

                    // Cambia el estado del puerto seleccionado a true
                    this.actionSetPuertosSeleccionadosPlanAnual({id_tab: 1, estado: true});

                } else {

                    // Quita data de la fila seleccionada
                    this.checkPlanificacionAnual.filter((item) => item.id != index && check_filtrado.push(item));

                    this.actionSetCheckPlanificacionAnual(check_filtrado);

                    // Cambia el estado del puerto seleccionado a false
                    this.actionSetPuertosSeleccionadosPlanAnual({id_tab: 1, estado: this.check_seleccionados.length ? true : false});
                    
                }

            },

            async eliminarFila(index){

                this.$vToastify.loader('Eliminando puertos');

                let annual_plan_id = this.dataAnioSeleccionado[index].data_complementaria.annual_plan_id;
                let port_id        = this.dataAnioSeleccionado[index].data_complementaria.port_id;
                let isNew          = this.dataAnioSeleccionado[index].new;
                let sql            = '';

                const data = { "plan_id":annual_plan_id, "port_id":port_id};

                if (!isNew) {
                    sql = await eliminarPuertos({ "plans" : [data] });

                    if (sql.code == 200) {
                        this.actionSetDataPlanificacionAnualTabla();
                        this.$vToastify.stopLoader();
                        this.$vToastify.success( sql.message, "Proceso finalizado");
                    } else {
                        this.$vToastify.stopLoader();
                        this.$vToastify.error( sql.message, "Proceso finalizado");
                    }

                } else {

                    this.actionSetPuertoParaEliminarPlanificacionAnual(index);
                    this.$delete(this.dataAux, index);

                    setTimeout(() => {

                        this.actionSetDataPlanificacionAnualTabla();
                        this.$vToastify.stopLoader();
                        this.$vToastify.success( "Puertos eliminados en local", "Proceso finalizado");

                    }, 1000);

                }
                
            },

            eliminarFilaWatch(index){
                this.$delete(this.dataAux, index)
            }
        },
        
        watch : {

            data : function(_new){

                if(_new){
                    this.dataAux = [];
                    this.check_seleccionados = [];
                    this.generarBotonesAcciones(_new);
                } 
                
            },

            nuevosConsolidadoMultiples : function(_new){

                if (_new) {

                    let { pod, contenedores, productos, consignatarios } = _new[_new.length - 1];

                    // Se agrega el nuevo registro al array que se recorre en la tabla
                    this.dataAux.push({
                        "id_puerto" : 0,
                        "data" : [false, pod.name, contenedores.name, productos.name, consignatarios.name, 0],
                        "acciones" : [
                            {
                                icon: "fa fa-times text-danger",
                                title: "Eliminar puerto",
                                id: this.dataAux.length,
                            },
                            {
                                icon: "fas fa-circle text-success",
                                title: "Puerto en lista para guardar",
                            }
                        ]
                    });
                    
                }

            },

            puertoParaEliminarPlanificacionAnual : function(_new){
                this.eliminarFilaWatch(_new)
            },

            checkPlanificacionAnual : function(_new){

                this.dataAux.map( (_, index_data) => {

                    this.dataAux[index_data].data[0] = false;

                    _new.map((checked) => checked.id == index_data && (this.dataAux[index_data].data[0] = true));

                    let dataTemp = this.dataAux;
                    this.dataAux = [];
                    this.dataAux = dataTemp;

                });

            }

        }

    }

</script>

<style scoped>

    #tabla_consolidado_anual > thead > th{
        text-align: center;
    }

    #switch_envio_correo > label > .ui-switch__input-wrapper {
        right: -7px !important;
    }

    table tfoot {
        position: sticky;
        bottom: 0;
        z-index: 1;
    }

    table tfoot td {
        padding: 15px 0;
        background: #bfbfbf;
    }

    table tr th:first-child {
        position: sticky;
        inset-inline-start: 0; /* "left" */
    }

</style>